module.exports = __webpack_public_path__ + "media/images/round-box@3x-2ab6b4bd71d6102c1e0f78502b23d5e6.png";